exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".summary-card[data-v-7b4bd826]{min-height:82px}.nomination-table[data-v-7b4bd826]{border:1px solid #e0e0e0;border-radius:4px}.empty-state[data-v-7b4bd826]{color:#607d8b}@media (max-width:960px){.nomination-table[data-v-7b4bd826]{overflow-x:auto}}", ""]);

// exports
